import { ResourcesMenu } from '@app/enums/_index';

/**
 * Static resource links used by the header
 */
const RESOURCES = {
  resource: [
    {
      name: ResourcesMenu.GETTING_STARTED,
      routerLink: '/training-support/getting-started',
      display: true,
    },
    {
      name: ResourcesMenu.LEARNING_PATHS,
      routerLink: '/learning-path/home',
      display: true,
    },
    {
      name: ResourcesMenu.CERTIFICATIONS,
      routerLink: '/certification/home',
      display: true,
    },
    {
      name: ResourcesMenu.VIDEOS,
      routerLink: '/videos',
      display: true,
    },
    {
      name: ResourcesMenu.VOUCHER_REDEMPTION,
      routerLink: '/voucher-redemption',
      display: true,
    },
    {
      name: ResourcesMenu.TERMS_AND_CONDITION,
      routerLink: '/terms-and-conditions',
      display: true,
    },
  ],
};

export default RESOURCES;
